import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileNav from "@/components/MobileNav";
import HomePage from "@/pages/HomePage";
import StreetwearPage from "@/pages/StreetwearPage";
import BeautyPage from "@/pages/BeautyPage";
import { trackPageView } from "@/lib/analytics";

function App() {
  useEffect(() => {
    // Make French the document language
    document.documentElement.setAttribute("lang", "fr");
    trackPageView();
  }, []);

  return (
    <div className="App min-h-screen text-white antialiased selection:bg-[#E91E63] selection:text-white">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/expo-streetwear-sneaker-culture" element={<StreetwearPage />} />
          <Route path="/beauty-wellness-weekend" element={<BeautyPage />} />
        </Routes>
      </main>
      <Footer />
      <MobileNav />
    </div>
  );
}

export default App;
